module.exports = __webpack_public_path__ + "img/img25.4a73d582.png";